import React from "react";
import { Card, CardContent } from "./ui/card";
import { Typography } from "./ui/typography";
import { TradeHeader } from "./TradeHeader";
import { QuoteTimerFooter } from "./QuoteTimerFooter";

interface QuoteConfirmationCardProps {
  title?: string;
  headerLabel?: string;
  assetSymbol?: string;
  assetName?: string;
  assetIcon?: string;
  amount: string;
  fiatAmount: string;
  children: React.ReactNode;
  timer: number;
  isTimerZero: boolean;
  confirmed: boolean;
  isLoadingQuote: boolean;
  isRefreshing: boolean;
  confirmButtonText: string;
  onBack: () => void;
  onRefresh: () => void;
  onConfirm: () => void;
  dashboard?: boolean;
}

export const QuoteConfirmationCard: React.FC<QuoteConfirmationCardProps> = ({
  title,
  headerLabel,
  assetSymbol,
  assetName,
  assetIcon,
  amount,
  fiatAmount,
  children,
  timer,
  isTimerZero,
  confirmed,
  isLoadingQuote,
  isRefreshing,
  confirmButtonText,
  onBack,
  onRefresh,
  onConfirm,
  dashboard = false,
}) => {
  return (
    <Card
      className={`w-full bg-white rounded-2xl ${dashboard ? "!shadow-none" : ""}`}
    >
      <div className="px-6 pt-8">
        {title && (
          <Typography
            variant="h2"
            className="text-lg font-medium text-text-primary mb-4"
          >
            {title}
          </Typography>
        )}
        <TradeHeader
          label={headerLabel}
          assetSymbol={assetSymbol}
          assetName={assetName}
          assetIcon={assetIcon}
          amount={amount}
          fiatAmount={fiatAmount}
          isSmall={true}
        />
      </div>

      <CardContent className="px-6 mt-6">
        <Typography
          variant="h3"
          className="text-base font-medium text-text-secondary mb-3"
        >
          Transaction details
        </Typography>

        <div className="border rounded-lg divide-y">{children}</div>
      </CardContent>

      <QuoteTimerFooter
        timer={timer}
        isTimerZero={isTimerZero}
        confirmed={confirmed}
        isLoadingQuote={isLoadingQuote}
        isRefreshing={isRefreshing}
        confirmButtonText={confirmButtonText}
        onBack={onBack}
        onRefresh={onRefresh}
        onConfirm={onConfirm}
        dashboard={dashboard}
      />
    </Card>
  );
};
